import { render, staticRenderFns } from "./EditProjectDetail.vue?vue&type=template&id=29c7a23d"
import script from "./EditProjectDetail.vue?vue&type=script&lang=js"
export * from "./EditProjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports